/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../../helpers'
import PropTypes from 'prop-types'
import { Header3, Text } from '../../../../styles/Components'
import { gsColors } from '../../../../styles/Variables'
import { formatCurrency, formatDurationDisplay } from '../../../../helpers'

/**
 * MarketService
 *
 * @param {*} {
 *   marketService,
 *   popular
 * }
 * @returns
 */

const MarketServiceButton = styled.button`
  box-sizing: border-box;
  display: flex;
  padding: 34px 20px;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
  align-self: stretch;
  border: 1px solid ${gsColors.lightTangerine};
  background-color: #FFF;
  cursor: pointer;
  width: 100%;
  max-width: 405px;
  height: 205px;

  &:hover {
    border: 2px solid ${gsColors.sunsetOrange};
  }

  ${mq('max', '849px')} {
    max-width: unset;
    width: 100%;
    padding: 28px 20px;
  }
  
  .title, .description, .info {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .title {
    justify-content: space-between;
    align-items: center;

    h3 {
      text-transform: capitalize;

      ${mq('max', '768px')} {
        font-size: 20px !important;
      }
    }

    .popular {
      padding: 3px 7px;
      background-color: ${gsColors.tangerine};
    }
  }

  .description {
    
    p {
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;

      ${mq('max', '768px')} {
        font-size: 16px !important;
      }
    }
  }

  .info {
    p {
      ${mq('max', '768px')} {
        font-size: 16px;
      }
    }
    .duration {
      display: flex;
      align-items: center;
    }
  }
`

const MarketService = ({ marketService, popular, onClick }) => {
  const {
    price,
    duration,
    service: {
      name: serviceName,
      description: serviceDescription,
    }
  } = marketService
  
  return (
    <MarketServiceButton
      role="button"
      onKeyPress={e => (e.key === 'Enter' ? onClick() : false)}
      tabIndex={0}
      {...{ popular, onClick }}
    >
      <div className='title'>
        <Header3
          lineHeight='140%'
        >
          {serviceName.toLowerCase()}
        </Header3>
        {!!popular && (
          <div className='popular'>
            <Text 
              color='#FFF'
              fontSize={14}
              weight={500}
              lineHeight='138%'
              spacing={1}
            >
              POPULAR
            </Text>
          </div>
        )}
      </div>
      <div className='description'>
        <Text
          color={gsColors.meredithGrey}
          lineHeight='145%'
          spacing={0.16}
          align='left'
        >
          {serviceDescription.slice(0, 200)}
        </Text>
      </div>
      <div className='info'>
        <Text
          weight={600}
          lineHeight='145%'
        >
          {/* price is 0 for event services */}
          {price !== 0 && 'Starting at ' + formatCurrency(price)}
        </Text>
        <div className='duration'>
          {!!duration && (<>
            <img src='/images/book-icon-time.svg' alt='clock icon' />
            <Text margin='0 0 0 8px'>
              {formatDurationDisplay(duration, marketService)} mins
            </Text>
          </>)}
        </div>
      </div>
    </MarketServiceButton>
  )
}

MarketService.propTypes = {
  marketService: PropTypes.object.isRequired,
  popular: PropTypes.bool.isRequired
}

export default MarketService
